import { FeatureFlagsDto, featureFlagsClient } from 'api/planning';
import { api } from '../api';

export const featureFlagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<FeatureFlagsDto, void>({
      query: () => featureFlagsClient.getAll(),
    }),
  }),
});

export const { useGetFeatureFlagsQuery } = featureFlagsApi;
